import React, { createContext, useContext } from 'react';
import { ApiInvitationRepository } from '../repositories/ApiInvitationRepository';
import { SendInvitationUseCase } from '../../application/use-cases/SendInvitationUseCase';
import { FetchInvitationLocationsUseCase } from '../../application/use-cases/FetchInvitationLocationsUseCase';
import { useHttpClientCore } from '@/shared/infra/http/HttpClientContext';

interface InvitationDIContextType {
    sendInvitationUseCase: SendInvitationUseCase;
    fetchInvitationLocationsUseCase: FetchInvitationLocationsUseCase;
}

const InvitationDIContext = createContext<InvitationDIContextType | undefined>(undefined);

export const InvitationDIProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const httpClient = useHttpClientCore();
    const repository = new ApiInvitationRepository(httpClient);
    const sendInvitationUseCase = new SendInvitationUseCase(repository);
    const fetchInvitationLocationsUseCase = new FetchInvitationLocationsUseCase(repository);

    return (
        <InvitationDIContext.Provider
          value={{ sendInvitationUseCase, fetchInvitationLocationsUseCase }}
        >
            {children}
        </InvitationDIContext.Provider>
    );
};

export const useInvitationDIContext = () => {
    const context = useContext(InvitationDIContext);
    if (!context) {
        throw new Error('useInvitationDIContext must be used within an InvitationDIProvider');
    }
    return context;
};
